/**
 * Single source of truth for backend and API base URLs.
 * Set REACT_APP_BACKEND_URL at build time (see scripts/set-vercel-backend-url.js).
 */

const DEFAULT_BACKEND_URL = "https://careprotest.aretehealth.tech";
// const DEFAULT_BACKEND_URL = "https://localhost:3000";

// const DEFAULT_BACKEND_URL = "https://pro.aretehealth.tech";

/** Origin for REST API and Socket.IO (no path suffix). */
export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL?.trim() || DEFAULT_BACKEND_URL;

/** REST API base path used by ApiClient and axios refresh calls. */
export const serverURL = `${BACKEND_URL}/prod/api/v1`;

/**
 * @deprecated Prefer serverURL. Kept for modules that imported API_BASE_URL from config/api.ts.
 */
export const API_BASE_URL = serverURL;
